import * as types from './types'

export default {
  setLecture({ commit }, lecture) {
    commit(types.SET_LECTURE, { data: lecture })
  },
}
